export const LC_PRODUCT_STATE_NEW = 'NEW';
export const LC_PRODUCT_STATE_UPDATED = 'UPDATED';
export const LC_PRODUCT_STATE_PROCESSING = 'PROCESSING';
export const LC_PRODUCT_STATE_LIVE_IN_COLLECTION = 'LIVE';
export const LC_PRODUCT_STATE_LIVE_INACTIVE = 'INACTIVE';
